import { useMsal } from '@azure/msal-react';
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Avatar, Box, IconButton, Toolbar } from '@mui/material';
import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import HomeImage from '../../assets/logo.png';
import APIFetcher from '../remoteData/APIFetcher';

interface HeaderProps {
  onDrawerToggle: () => void;
}

export default function Header({ onDrawerToggle }: HeaderProps) {
  const { instance } = useMsal();
  const [profileImageUrl, setProfileImageUrl] = useState('');

  useEffect(() => {
    async function loadProfilePicture() {
      const api = new APIFetcher(instance);
      const profilePicture = await api.getProfilePictures();

      if (profilePicture !== 500) {
        setProfileImageUrl(URL.createObjectURL(profilePicture));
      }
    }

    loadProfilePicture();
  }, [instance]);

  return (
    <header>
      <AppBar
        sx={{
          zIndex: 999,
          backgroundColor: '#0d1523',
          color: 'white',
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between', paddingX: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={onDrawerToggle}
              edge="start"
              sx={{
                color: 'white',
                '&:focus': { outline: 'none' },
                display: { xs: 'block', sm: 'none' },
              }}
              size="large"
            >
              <MenuIcon />
            </IconButton>
            <NavLink to="/">
              <Box component="img" sx={{ width: 200, height: 'auto' }} src={HomeImage} alt="BLKLOGO" />
            </NavLink>
          </Box>

          {profileImageUrl && (
            <Avatar
              src={profileImageUrl}
              sx={{
                color: '#fafafa',
                backgroundColor: 'purple',
                cursor: 'pointer',
              }}
            >
              JS
            </Avatar>
          )}
        </Toolbar>
      </AppBar>
    </header>
  );
}
